const formatUploadsArray = (uploadsArray) => {
  return uploadsArray.map((file) => ({
    ref: file.reference || file.ref,
    category: file.category,
  }));
};

export default formatUploadsArray;
